import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  makeStyles,
  Spinner,
} from "@fluentui/react-components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useGetDocumentFields,
  useGetLinkFields,
  useGetToolHistory,
} from "../../hooks/useTools";
import { ToolTypes } from "../../models/Tool";
import { getToolType } from "../../services/ToolService";
import ToolHistoryList from "./ToolHistoryList";

const useStyles = makeStyles({
  dialogSurface: {
    minWidth: "1000px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  commentTextArea: {
    minHeight: "150px",
  },
  commentLabel: {
    marginTop: "20px",
  },
});

interface ToolHistoryDialogProps {
  toolId: string;
}

export const ToolHistoryDialog = (props: ToolHistoryDialogProps) => {
  const { toolId } = props;
  const { data: tools, isLoading: loadingHistory } = useGetToolHistory(toolId);
  const { data: documentFields, isLoading: documentFieldsLoading } =
    useGetDocumentFields();
  const { data: linkFields, isLoading: linkFieldsLoading } = useGetLinkFields();
  const { t } = useTranslation();

  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);

  const toolType =
    tools && tools.length > 0 ? getToolType(tools[0]) : undefined;
  const viewDefinition =
    toolType === ToolTypes.Document ? documentFields : linkFields;
  const isLoading =
    loadingHistory || documentFieldsLoading || linkFieldsLoading;

  return (
    <Dialog open={open}>
      <DialogTrigger disableButtonEnhancement>
        <Button onClick={() => setOpen(true)}>{t("showHistory")}</Button>
      </DialogTrigger>
      <DialogSurface
        className={classes.dialogSurface}
        aria-describedby={undefined}
      >
        <DialogBody>
          <DialogTitle>{t("history")}</DialogTitle>
          <DialogContent>
            {isLoading && <Spinner />}
            {!isLoading && tools && viewDefinition && (
              <ToolHistoryList
                tools={tools}
                toolFields={viewDefinition.fields}
              />
            )}
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button onClick={() => setOpen(false)} appearance="secondary">
                {t("close")}
              </Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default ToolHistoryDialog;
